<ng-container *ngFor="let message of (messages$ | async)">
  <emperor-message-alert [message]="message"></emperor-message-alert>
</ng-container>
